import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { IntegrationBase } from "@/features/Integrations/types/integration";
import { integrationBaseQueryKey } from "@/features/Integrations/utils/integrationTabs";

/**
 * Depois de gravar algo na página da integração (AB#87542): a instância que a api devolveu
 * passa a ser a da página, e a lista de `/integrations` recarrega — o card mostra title,
 * escopo e status.
 */
export function useIntegrationBaseCache() {
  const queryClient = useQueryClient();
  return useCallback(
    async (updated: IntegrationBase | null | undefined, id: string) => {
      if (updated && updated.id) {
        queryClient.setQueryData(integrationBaseQueryKey(id), updated);
      } else {
        await queryClient.invalidateQueries({ queryKey: integrationBaseQueryKey(id) });
      }
      await queryClient.invalidateQueries({ queryKey: ["integrations-base"] });
    },
    [queryClient],
  );
}
